import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogCategoryForm from "./BlogCategoryForm";
import { createBlog } from "../../api/BlogCategoryService";

const SEO_REFERENCE_TYPE = "BlogCategory";

const BlogCategoryadd = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const categoryPayload = {
        name: values.name,
        description: values.description,
        status: values.status,
        referenceType: SEO_REFERENCE_TYPE,
        metaTitle: values.metaTitle || values.name || "",
        metaDescription: values.metaDescription || "",
        metaKeywords: Array.isArray(values.metaKeywords)
          ? values.metaKeywords
          : (values.metaKeywords || "")
              .split(",")
              .map((item) => item.trim())
              .filter(Boolean),
        metaImage: values.metaImage || "",
      };

      const categoryRes = await createBlog(categoryPayload);
      if (categoryRes?.success === false || categoryRes?.status === 422) {
        setErrors(categoryRes?.error || categoryRes?.data || categoryRes || {});
        return;
      }

      navigate("/blogcategory");
    } catch (error) {
      console.error(error);

      const responseData = error?.response?.data;
      const responseErrors =
        responseData?.error || responseData?.errors || responseData || error?.error || { message: error?.message || "Submit failed" };

      setErrors({
        ...(typeof responseErrors === "object" && responseErrors),
        message:
          responseData?.message ||
          responseErrors?.message ||
          error?.message ||
          "Submit failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogCategoryForm
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onCancel={() => navigate("/blogcategory")}
    />
  );
};

export default BlogCategoryadd;
